import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql } from 'react-apollo';
import { compose, mapProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import Button from 'components/common/Buttons/Button';
import ThreeppModal from 'components/common/Modal/Modal';
import { submitAssessment as submitAssessmentMut } from 'graphql/operations';
import { showSuccessMessage, showErrorMessage } from 'components/common/Alert/Alert';
import { getIdFromUrlParams } from 'selectors/assessment/selector';

import './SubmitModal.scss';

export const SubmitModal = props => {
  const { toggle, isOpen, submitAssessment } = props;
  const { t } = useTranslation();

  const close = useCallback(() => {
    toggle();
  }, [toggle]);

  const handleSubmtAssessment = useCallback(() => {
    submitAssessment()
      .then(() => {
        showSuccessMessage(t('assessment.submit.successMsg'));
      })
      .catch(() => {
        showErrorMessage(t('assessment.submit.errorMsg'));
      });

    close();
  }, [submitAssessment, close, t]);

  return (
    <>
      <ThreeppModal isOpen={isOpen} toggle={toggle} classes="submit-modal" header={t('assessment.submit.header')} size="sm">
        <div className="submit-content">{t('assessment.submit.confirmation')}</div>

        <div className="action-row">
          <Button className="btn-cancel" buttonStyle="destructive" onClick={close}>
            {t('common.cancel')}
          </Button>

          <Button className="btn-submit" buttonStyle="primary" onClick={handleSubmtAssessment}>
            {t('assessment.submit.submit')}
          </Button>
        </div>
      </ThreeppModal>
    </>
  );
};

export const SubmitModalHOC = compose(
  withRouter,
  graphql(submitAssessmentMut, {
    options: props => ({
      variables: {
        assessmentId: getIdFromUrlParams(props)
      }
    }),
    name: 'submitAssessment'
  }),
  mapProps(props => {
    const { toggle, isOpen, submitAssessment } = props;
    return {
      toggle,
      isOpen,
      submitAssessment
    };
  })
);

export default SubmitModalHOC(SubmitModal);
